import { FolderCategory } from "./enums"

interface Props {
  folder: FolderCategory,
  onClick: () => void,
}

const Folder: React.FC<Props> = ({
  folder,
  onClick,
}) => {
  return (
    <div
      className={`w-full h-[111px] rounded-[5px] flex items-center justify-center self-center flex-shrink-0 shadow-platform cursor-pointer p-[20px] ${folder === FolderCategory.MealPlan ? "bg-[#C2D9FF]" : "bg-white"}`}
      onClick={onClick}
    >
      <div className="w-full">
        <div className="font-bold text-[20px] leading-[33px]">{handleFolderName(folder)}</div>
      </div>
    </div>
  )
}

export default Folder

const handleFolderName = (folder: FolderCategory) => {
  switch (folder) {
    case FolderCategory.Results:
      return `${"\u{1F4CA}"} Risultati e progressi`
    case FolderCategory.TestsDocs:
      return `${"\u{1F4C1}"} Test e referti`
    case FolderCategory.DNATest:
      return `${"\u{1F9EC}"} DNA Test`
    case FolderCategory.BloodExams:
      return `${"\u{1FA78}"} Analisi degli Aminoacidi`
    case FolderCategory.HealthAssessment:
      return `${"\u{1F4DD}"} Health Assessment`
    case FolderCategory.UploadedForYou:
      return `${"\u{1F5C2}"} Caricati per te`
    case FolderCategory.UploadedFromYou:
      return `${"\u{1F5C2}"} Caricati da te`
    case FolderCategory.PaymentMethod:
      return `${"\u{1F4B3}"} Gestione abbonamento`
    case FolderCategory.Appointments:
      return `🗓️ I tuoi appuntamenti`
    case FolderCategory.Experts:
      return `👩‍⚕️👨‍⚕️ I tuoi Professionisti`
    case FolderCategory.MealPlan:
      return "🍲 Meal Plan"
    case FolderCategory.OldHealthPlans:
      return "Health Plan passati"
    case FolderCategory.OldMealPlans:
      return "Meal Plan passati"
    case FolderCategory.Emr:
      return "🫀 Emr"
  }
}
